var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_1113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4L0 16C0 17.0609 0.421427 18.0783 1.17157 18.8284C1.92172 19.5786 2.93913 20 4 20H6.9L11.351 23.763C11.5316 23.9158 11.7605 23.9997 11.997 23.9997C12.2335 23.9997 12.4624 23.9158 12.643 23.763L17.1 20H20C21.0609 20 22.0783 19.5786 22.8284 18.8284C23.5786 18.0783 24 17.0609 24 16V4C24 2.93913 23.5786 1.92172 22.8284 1.17157C22.0783 0.421427 21.0609 0 20 0V0ZM22 16C22 16.5304 21.7893 17.0391 21.4142 17.4142C21.0391 17.7893 20.5304 18 20 18H17.1C16.6273 18.0001 16.1699 18.1677 15.809 18.473L12 21.69L8.193 18.473C7.83156 18.1673 7.3734 17.9997 6.9 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H20C20.5304 2 21.0391 2.21071 21.4142 2.58579C21.7893 2.96086 22 3.46957 22 4V16Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7.00015H12C12.2652 7.00015 12.5196 6.89479 12.7071 6.70726C12.8946 6.51972 13 6.26537 13 6.00015C13 5.73493 12.8946 5.48058 12.7071 5.29305C12.5196 5.10551 12.2652 5.00015 12 5.00015H7C6.73478 5.00015 6.48043 5.10551 6.29289 5.29305C6.10536 5.48058 6 5.73493 6 6.00015C6 6.26537 6.10536 6.51972 6.29289 6.70726C6.48043 6.89479 6.73478 7.00015 7 7.00015Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9H7C6.73478 9 6.48043 9.10536 6.29289 9.29289C6.10536 9.48043 6 9.73478 6 10C6 10.2652 6.10536 10.5196 6.29289 10.7071C6.48043 10.8946 6.73478 11 7 11H17C17.2652 11 17.5196 10.8946 17.7071 10.7071C17.8946 10.5196 18 10.2652 18 10C18 9.73478 17.8946 9.48043 17.7071 9.29289C17.5196 9.10536 17.2652 9 17 9Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12.9999H7C6.73478 12.9999 6.48043 13.1052 6.29289 13.2928C6.10536 13.4803 6 13.7346 6 13.9999C6 14.2651 6.10536 14.5194 6.29289 14.707C6.48043 14.8945 6.73478 14.9999 7 14.9999H17C17.2652 14.9999 17.5196 14.8945 17.7071 14.707C17.8946 14.5194 18 14.2651 18 13.9999C18 13.7346 17.8946 13.4803 17.7071 13.2928C17.5196 13.1052 17.2652 12.9999 17 12.9999Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_1113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageChat);
export default __webpack_public_path__ + "static/media/messageChat.09a6bbb630088e3281aae66f3c265978.svg";
export { ForwardRef as ReactComponent };